import { AlertCircle, Clock } from "lucide-react";
import { getAppointmentWarningMessage } from "@/utils/appointmentUtils";

const AppointmentWarning = () => {
  const message = getAppointmentWarningMessage();
  const currentHour = new Date().getHours();
  const isAfter6PM = currentHour >= 18;

  return (
    <div
      className={`flex items-start gap-3 p-4 rounded-lg border ${
        isAfter6PM
          ? "bg-red-50 border-red-200"
          : "bg-blue-50 border-blue-200"
      }`}
    >
      {isAfter6PM ? (
        <AlertCircle className="w-5 h-5 text-red-600 mt-0.5 flex-shrink-0" />
      ) : (
        <Clock className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
      )}
      <p
        className={`text-sm ${
          isAfter6PM ? "text-red-800" : "text-blue-800"
        }`}
      >
        {message}
      </p>
    </div>
  );
};

export default AppointmentWarning;
